module.exports = __webpack_public_path__ + "static/media/Ekran.16c4346a.png";